import * as React from 'react';
import {Field, FieldProps} from 'formik';
import {TaskObject} from 'api/task/types';
import {SettingsGroup} from 'components/SettingsGroup';
import Row from 'components/Row';
import Column from 'components/Column';
import Input from 'components/Input';

/**
 * The limit form of the task settings.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Limit(): React.ReactElement {
  return (
    <SettingsGroup<TaskObject['settings']>
      name="limit"
      title="Ограничить прохождение задания по времени"
      description="Задания со свободным ответом в таймере не учитываются. Для студента они будут отображаться отдельно."
    >
      <Row>
        <Column>
          <Field name="settings.limit.minutes">
            {({field}: FieldProps) => (
              <Input
                {...field}
                type="number"
                min={1}
                label="Введите время(в минутах)"
                placeholder="1 минута"
                required
              />
            )}
          </Field>
        </Column>
      </Row>
    </SettingsGroup>
  );
}
